const activities = {
  activitiesPage: {
    header: {
      overline: "COMMUNITY & KNOWLEDGE",
      titlePrefix: "Public",
      titleHighlight: "Activities",
      subtitle: "Sharing insights and expertise through speaking, writing, and training to push the boundaries of Data Science and AI.",
    },
    errors: {
      load: "Error loading activities: {{error}}",
    },
    card: {
      explore: "Explore Activity",
    },
    cta: {
      titlePrefix: "Book for your next",
      titleHighlight: "Event",
      subtitle:
        "Looking for a speaker on AI, Data Science, or SaaS Architecture? Let's discuss how I can bring value to your conference, meetup, or training program.",
      button: "Get in Touch",
    },
  },
  activityDetail: {
    errors: {
      notFound: "Activity not found",
    },
    backToList: "Back to Activities",
    sections: {
      overview: "Overview",
      gallery: "Gallery",
    },
    sidebar: {
      takeAction: "Take Action",
      viewResource: "View Resource",
      contactAboutThis: "Contact About This",
      relatedTitle: "You Might Also Like",
    },
  },
};

export default activities;
